import { Component, input } from '@angular/core'
import { Order } from 'src/app/shared/interfaces/orders/order.interface'
import { OrderCardComponent } from '../order-card/order-card.component'
import { EmptyComponent } from '../../empty/empty.component'

@Component({
    selector: 'sf-orders-table',
    imports: [OrderCardComponent, EmptyComponent],
    templateUrl: './orders-table.component.html',
    styleUrl: './orders-table.component.scss',
})
export class OrdersTableComponent {
    orders = input.required<Order[]>()
}
